export class Menu {

    public init()
    {
        this.handleToggle();
        this.handleShrink();
        this.handleAnchor();
        this.markActive();
    }

    // handle handheld menu toggle
    private handleToggle() {
        $(document).on("click", ".c-nav-header__toggle", (event: JQuery.Event): boolean => {
            $("body").toggleClass("c-nav-header--expanded");
            return true;
        });
    }

    // handle logo shrink on scroll
    private handleShrink() {
        $(window).scroll(function () {
            if ($(document).scrollTop() == 0) {
                $('.c-page-header').removeClass('tiny');
            } else {
                $('.c-page-header').addClass('tiny');
            }
        });
    }

    private handleAnchor() {        
        $(function() {
            var list = $('.c-anchorblock__menu ul');        
            $('a[id]').each(function() {
                $(this).attr("href","#"+($(this).parent("div").next("div").attr("id")));
                $(list).append('<li><a href="#' + ($(this).attr("id") + '">' +  ($(this).attr("id") + '</a></li>')));                
            });
        });   
    }

    // Set the active menu items based on page url
    private markActive() {
        $("a[href='" + document.location.pathname + "']").each((index, element) => {
            $(element).parentsUntil("nav").each((index, element) => {
                if (element.tagName == "LI") {
                    $(element).addClass($(element).attr("class") + "--active")
                }
            });
        });
    }
}